__turbopack_context__.v({
  "Cont": "List-module-sass-module__hy9Q5G__Cont",
  "Intro": "List-module-sass-module__hy9Q5G__Intro",
  "List": "List-module-sass-module__hy9Q5G__List",
  "YearFilter": "List-module-sass-module__hy9Q5G__YearFilter",
});
